var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-form',{ref:"queryForm",staticClass:"special-function-base-query",attrs:{"labelWidth":"120px","form-items":_vm.baseFormItems,"inline":""},model:{value:(_vm.baseQueryFormObj),callback:function ($$v) {_vm.baseQueryFormObj=$$v},expression:"baseQueryFormObj"}})
}
var staticRenderFns = []

export { render, staticRenderFns }